"use client";

import {useConfig} from '@/hooks/use-config';
import {LoggerProvider} from '@rpds/react-utils';

/**
 * Client-side logging provider for the entire app
 *
 * This component:
 * 1. Fetches the client config (including logsUrl)
 * 2. Wraps the app with LoggerProvider from @rpds/react-utils
 * 3. Enables log batching (every 2s) and beforeunload flushing
 *
 * Features provided by LoggerProvider:
 * - Batches logs and flushes every 2 seconds (reduces HTTP requests)
 * - Flushes logs before page unload (prevents log loss)
 * - Provides useLogger() hook for components
 * - SSR-safe (sends logs immediately during SSR)
 *
 */
export function LoggingProvider({children}: {children: React.ReactNode}) {
  const {config, isLoading} = useConfig();

  // Wait for config to load before rendering LoggerProvider
  if (isLoading || !config) {
    return <>{children}</>;
  }

  return (
    <LoggerProvider apiUrl={config.logsUrl}>
      {children as any}
    </LoggerProvider>
  );
}
